import React, { useState, useEffect } from 'react';
import { FaArrowUp } from "react-icons/fa";


const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      style={{ ...buttonStyle, display: isVisible ? 'block' : 'none' }}
    >
      <FaArrowUp/>
    </button>
  );
};

const buttonStyle = {
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  padding: '10px 20px',
  backgroundColor: 'hsl(26, 93%, 50%)',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  cursor: 'pointer'
};

export default ScrollToTopButton;
